import { Validators } from '@angular/forms';
import { SpecFieldNames } from '@ordersnproducts/modules/order-builder/modules/specification/constants/specification-field-names.enum';
import { UNITS } from '@ordersnproducts/modules/shared/constants/units';
import { FormInputCheckboxComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-input-checkbox/form-input-checkbox.component';
import { FormInputNumberComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-input-number/form-input-number.component';
import {
  FieldConfig,
  NewLineField,
} from '@ordersnproducts/modules/shared/modules/configurable-form/models/field-configs/field-config.interface';
import { FieldInputNumberConfig } from '@ordersnproducts/modules/shared/modules/configurable-form/models/field-configs/field-input-number-config.interface';
import { FormSelectComponent } from '../../../../../../../shared/modules/configurable-form/components/form-select/form-select.component';
import { FieldSelectConfig } from '../../../../../../../shared/modules/configurable-form/components/form-select/models/field-select-config.interface';
import { generateAddedValueFormName } from '../../../../helpers/form-added-value-name-generator';
import { AddedValueFieldConfig } from '../../../../models/form-added-value-field-config';
import { RmsFormConfig } from '../../../../models/rms-form-config';
import { FormTextAreaComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-textarea/form-textarea.component';
import { CutOffEffects } from '../../../../effects/cut-off.effects';
import { FormInfoIconMessageComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-info-icon-message/form-info-icon-message.component';
import { DirectProjectProfilesOptionLoader } from '../../../../services/config-loader/loaders/direct-project-profile.service.loader';
import { SingleCatalogsEffects } from '../../../../effects/single-catalogs.effects';
import {
  SingleApplicationsLoaderService,
  SingleSlumpProductLoaderService,
  SingleSpacingsLoaderService,
  SingleUnloadTypesLoaderService,
} from '../../../../services/config-loader/loaders/single-catalogs.loader.service';
import { SetProjectPropertiesCommand } from '@ordersnproducts/modules/order-builder/modules/specification/services/commands/set-project-properties.command';
import { SetProjectProfileSlumpCommand } from '../../../../services/config-loader/commands/set-project-profile-slump.command.service';
// product form field
import { ProductsOptionsLoaderOpenPlatformService } from '@ordersnproducts/modules/order-builder/modules/rms-specification/services/config-loader/loaders/open-platform/products.loader.service';
import { ProductsOpenPlatformEffects } from '@ordersnproducts/modules/order-builder/modules/rms-specification/effects/open-platform/products.effects';
import { ProductsDisablerOpenPlatformProvider } from '@ordersnproducts/modules/order-builder/modules/rms-specification/providers/open-platform/product-enabler.provider';
import { LoadContractBalanceOpenPlatformCommandService } from '@ordersnproducts/modules/order-builder/modules/rms-specification/services/config-loader/commands/open-platform/load-contract-balance.command.service';
import { LoadSingleCatalogsProjectProfile } from '@ordersnproducts/modules/order-builder/modules/rms-specification/services/config-loader/commands/single-catalogs-project-profile.command.service';
import { LoadProductAddedValuesNotFormulatingOpenPlatformCommandService } from '@ordersnproducts/modules/order-builder/modules/rms-specification/services/config-loader/commands/open-platform/load-added-value-not-formulating.command.service';
// quantity form field
import { RmsMaximumCapacityOpenPlatformProvider } from '@ordersnproducts/modules/order-builder/modules/rms-specification/providers/open-platform/rms-maximum-capacity.provider';
import { HandleRemainingBalanceOpenPlatformCommand } from '@ordersnproducts/modules/order-builder/modules/specification/services/commands/open-plaftorm/handle-remaining-balance-validation.command';
// contract form field
import { ContractsBalanceOptionLoaderOpenPlatformService } from '@ordersnproducts/modules/order-builder/modules/rms-specification/services/config-loader/loaders/open-platform/contract-balance.loader.service';
import { SetPaymentTermOpenPlatformCommandService } from '@ordersnproducts/modules/order-builder/modules/rms-specification/services/config-loader/commands/open-platform/set-contract-payment.command.service';
import { RmsHandleMaximumCapacityOpenPlatformService } from '@ordersnproducts/modules/order-builder/modules/rms-specification/services/config-loader/commands/open-platform/rms-handle-max-capacity.command.service';
// payment term form field
import { PaymentTermsOptionLoaderOpenPlatformService } from '@ordersnproducts/modules/order-builder/modules/rms-specification/services/config-loader/loaders/open-platform/contract-payment-term-loader.service';
// value addeds form fields
import { AddedValueOpenPlatformDisabler } from '@ordersnproducts/modules/order-builder/modules/rms-specification/providers/open-platform/added-value-enabler.provider';
import { AddedValuesLoaderOpenPlatformService } from '@ordersnproducts/modules/order-builder/modules/rms-specification/services/config-loader/loaders/open-platform/added-value.loader.service';
import { LoadChildAddedValuesNotFormulatingOpenPlatformCommandService } from '@ordersnproducts/modules/order-builder/modules/rms-specification/services/config-loader/commands/open-platform/load-added-value-not-formulating.command.service';
import { LoadSingleCatalogsUnloadType } from '../../../../services/config-loader/commands/single-catalogs-unload-type.command.service';
import { LoadSingleCatalogsApplication } from '../../../../services/config-loader/commands/single-catalogs-application.command.service';
import { LoadSingleCatalogsSpacing } from '../../../../services/config-loader/commands/single-catalogs-spacing.command.service';
import { LoadSingleCatalogsUnloadTime } from '../../../../services/config-loader/commands/single-catalogs-unload-time.command.service';
import { LoadSingleCatalogsLoadSize } from '../../../../services/config-loader/commands/single-catalogs-load-size.command.service';
import { LoadSingleCatalogsSlumpProduct } from '../../../../services/config-loader/commands/single-catalogs-SlumpProduct.command.service';
import { FormInputComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-input/form-input.component';
import { SpecFieldTestIds } from '@ordersnproducts/modules/order-builder/modules/specification/constants/specification-field-test-ids.enum';

export const rmsUL = {
  recipe: [
    {
      type: FormInputComponent,
      label: 'id',
      name: SpecFieldNames.ID,
      containerClassNames: ['d-none'],
      placeholder: 'id',
    } as FieldConfig,
    {
      type: FormSelectComponent,
      label: 'views.specifications.product_description',
      name: SpecFieldNames.PRODUCT_SELECTION,
      dataTId: SpecFieldTestIds.PRODUCT_DESCRIPTION,
      containerClassNames: ['field-12x field-md-6x retail-control'],
      optionsLoader: ProductsOptionsLoaderOpenPlatformService,
      loading: ProductsDisablerOpenPlatformProvider.IsLoading,
      validation: [Validators.required],
      dynamicEffects: [ProductsOpenPlatformEffects, CutOffEffects],
      placeholder: 'views.specifications.select_product',
      onChange: [
        LoadContractBalanceOpenPlatformCommandService,
        LoadSingleCatalogsUnloadType,
        LoadSingleCatalogsApplication,
        LoadSingleCatalogsSpacing,
        LoadSingleCatalogsUnloadTime,
        LoadSingleCatalogsLoadSize,
        LoadSingleCatalogsSlumpProduct,
        LoadSingleCatalogsProjectProfile,
      ],
      rehydrate: true,
    } as FieldSelectConfig,
    {
      type: FormInputNumberComponent,
      label: 'views.specifications.quantity',
      containerClassNames: ['field-11x field-md-2x retail-control'],
      name: SpecFieldNames.QUANTITY,
      dataTId: SpecFieldTestIds.QUANTITY,
      min: 1,
      value: 1,
      step: 1,
      max: RmsMaximumCapacityOpenPlatformProvider.RmsMaxCapacity,
      message: RmsMaximumCapacityOpenPlatformProvider.MessageUsa,
      suffix: UNITS.CUBIC_YARD,
      validation: [Validators.required],
      decimals: 1,
      onChange: [HandleRemainingBalanceOpenPlatformCommand],
    } as FieldInputNumberConfig,
    {
      type: FormInfoIconMessageComponent,
      name: SpecFieldNames.CONCRETE_MIN_QUANTITY_INFO,
      dataTId: SpecFieldTestIds.CONCRETE_MIN_QUANTITY_INFO,
      value: false,
      containerClassNames: ['field-1x field-md-1x retail-control'],
      text: 'views.specifications.special-message',
    } as FieldConfig,
    {
      type: FormInputCheckboxComponent,
      name: SpecFieldNames.ADJUSTMENT,
      dataTId: SpecFieldTestIds.ADJUSTMENT,
      value: false,
      containerClassNames: ['field-6x field-md-2x retail-control specification-adjustment'],
      placeholder: 'views.specifications.kicker',
    } as FieldConfig,
    {
      type: null,
      push: true,
    } as NewLineField,
    {
      type: FormSelectComponent,
      label: 'views.specifications.contract',
      name: SpecFieldNames.CONTRACT_SELECT,
      dataTId: SpecFieldTestIds.CONTRACT_SELECT,
      containerClassNames: ['field-12x field-md-6x retail-control'],
      validation: [Validators.required],
      optionsLoader: ContractsBalanceOptionLoaderOpenPlatformService,
      placeholder: 'views.specifications.select_contract',
      onChange: [
        SetPaymentTermOpenPlatformCommandService,
        RmsHandleMaximumCapacityOpenPlatformService,
        LoadProductAddedValuesNotFormulatingOpenPlatformCommandService,
      ],
      rehydrate: true,
    } as FieldSelectConfig,
    {
      type: FormSelectComponent,
      label: 'views.specifications.paymentTerms',
      name: SpecFieldNames.PAYMENT_TERMS,
      dataTId: SpecFieldTestIds.PAYMENT_TERMS,
      containerClassNames: ['field-12x field-md-2x retail-control'],
      disabled: true,
      optionsLoader: PaymentTermsOptionLoaderOpenPlatformService,
    } as FieldSelectConfig,
    {
      type: null,
      push: true,
    } as NewLineField,
    {
      type: FormSelectComponent,
      label: 'views.specifications.valueAdded',
      name: generateAddedValueFormName(0),
      dataTId: SpecFieldTestIds.VALUE_ADDED_FIRST,
      index: 0,
      loading: AddedValueOpenPlatformDisabler.IsLoading,
      containerClassNames: ['field-12x field-md-3x retail-control'],
      optionsLoader: AddedValuesLoaderOpenPlatformService,
      onChange: [LoadChildAddedValuesNotFormulatingOpenPlatformCommandService],
      placeholder: 'views.specifications.select_valueAdded',
      rehydrate: true,
    } as AddedValueFieldConfig,
    {
      type: FormSelectComponent,
      label: 'views.specifications.valueAdded',
      name: generateAddedValueFormName(1),
      dataTId: SpecFieldTestIds.VALUE_ADDED_SECOND,
      index: 1,
      loading: AddedValueOpenPlatformDisabler.IsLoading,
      containerClassNames: ['field-12x field-md-3x retail-control'],
      onChange: [LoadChildAddedValuesNotFormulatingOpenPlatformCommandService],
      optionsLoader: AddedValuesLoaderOpenPlatformService,
      placeholder: 'views.specifications.select_valueAdded',
      rehydrate: true,
    } as AddedValueFieldConfig,
    {
      type: FormSelectComponent,
      label: 'views.specifications.valueAdded',
      name: generateAddedValueFormName(2),
      dataTId: SpecFieldTestIds.VALUE_ADDED_THIRD,
      index: 2,
      loading: AddedValueOpenPlatformDisabler.IsLoading,
      containerClassNames: ['field-12x field-md-3x retail-control'],
      onChange: [LoadChildAddedValuesNotFormulatingOpenPlatformCommandService],
      optionsLoader: AddedValuesLoaderOpenPlatformService,
      placeholder: 'views.specifications.select_valueAdded',
      rehydrate: true,
    } as AddedValueFieldConfig,
    {
      type: FormSelectComponent,
      label: 'views.specifications.valueAdded',
      name: generateAddedValueFormName(3),
      dataTId: SpecFieldTestIds.VALUE_ADDED_FOURTH,
      index: 3,
      loading: AddedValueOpenPlatformDisabler.IsLoading,
      limit: true,
      optionsLoader: AddedValuesLoaderOpenPlatformService,
      containerClassNames: ['field-12x field-md-3x retail-control'],
      placeholder: 'views.specifications.select_valueAdded',
      rehydrate: true,
    } as AddedValueFieldConfig,
    {
      type: FormSelectComponent,
      label: 'views.specifications.project_profiles',
      name: SpecFieldNames.PROJECT_PROFILES,
      dataTId: SpecFieldTestIds.PROJECT_PROFILES,
      containerClassNames: ['field-12x field-md-6x retail-control'],
      placeholder: 'views.specifications.select_projectProfiles',
      optionsLoader: DirectProjectProfilesOptionLoader,
      onChange: [SetProjectPropertiesCommand, SetProjectProfileSlumpCommand],
    } as FieldSelectConfig,
    {
      type: null,
      push: true,
    } as NewLineField,
    {
      type: FormSelectComponent,
      label: 'views.specifications.unload_type',
      name: SpecFieldNames.UNLOAD_TYPE,
      dataTId: SpecFieldTestIds.UNLOAD_TYPE,
      containerClassNames: ['field-12x field-md-3x retail-control'],
      value: 'DIRECT_FLOW',
      optionsLoader: SingleUnloadTypesLoaderService,
      validation: [Validators.required],
      disabled: true,
    } as FieldSelectConfig,
    {
      type: FormSelectComponent,
      label: 'views.specifications.application',
      name: SpecFieldNames.APPLICATION,
      dataTId: SpecFieldTestIds.APPLICATION,
      optionsLoader: SingleApplicationsLoaderService,
      containerClassNames: ['field-12x field-md-3x retail-control'],
      placeholder: 'views.specifications.select_application',
      validation: [Validators.required],
    } as FieldSelectConfig,
    {
      type: FormSelectComponent,
      label: 'views.specifications.spacing',
      name: SpecFieldNames.SPACING,
      dataTId: SpecFieldTestIds.SPACING,
      containerClassNames: ['field-12x field-md-3x retail-control'],
      placeholder: 'views.specifications.select_spacing',
      optionsLoader: SingleSpacingsLoaderService,
      validation: [Validators.required],
    } as FieldSelectConfig,
    {
      type: FormSelectComponent,
      label: 'views.specifications.slump',
      name: SpecFieldNames.SLUMP_PRODUCT,
      dataTId: SpecFieldTestIds.SLUMP,
      containerClassNames: ['field-12x field-md-3x retail-control'],
      placeholder: 'views.specifications.select_slump',
      optionsLoader: SingleSlumpProductLoaderService,
      validation: [Validators.required],
      dynamicEffects: [SingleCatalogsEffects],
    } as FieldSelectConfig,
    {
      type: null,
      push: true,
    } as NewLineField,
    {
      type: FormTextAreaComponent,
      label: 'views.specifications.additional_info',
      name: SpecFieldNames.ADDITIONAL_INFO,
      dataTId: SpecFieldTestIds.ADDITIONAL_INFO,
      containerClassNames: ['field-12x field-md-12x retail-control'],
      placeholder: 'views.specifications.enter_comment',
      maxlength: '63',
      validation: [],
    } as FieldConfig,
    {
      type: null,
      push: true,
    } as NewLineField,
  ],
} as RmsFormConfig;
